export const DEMO_SESSION_KEY = 'adflow_demo_session';

const readMarker = () => {
  try { return sessionStorage.getItem(DEMO_SESSION_KEY) === 'true'; }
  catch { return false; }
};

let demoActive = readMarker();

// Reset callbacks (e.g. the store) register here to avoid circular imports.
const onEnableCallbacks = [];
export function registerOnEnable(cb) { onEnableCallbacks.push(cb); }

export function isDemoMode() { return demoActive; }

export function enableDemo() {
  demoActive = true;
  try { sessionStorage.setItem(DEMO_SESSION_KEY, 'true'); } catch { /* ignore */ }
  onEnableCallbacks.forEach((cb) => cb());
}

export function disableDemo() {
  demoActive = false;
  try { sessionStorage.removeItem(DEMO_SESSION_KEY); } catch { /* ignore */ }
}

export function __resetDemoModeForTest() {
  demoActive = false;
  onEnableCallbacks.length = 0;
}
